import { ProductFruits } from 'react-product-fruits';
// utils
import { jwtDecode } from '@utils/jwt';
import { getAccessToken } from '@utils/session';
import { ProductType } from '../shared/layouts/dashboard/layout.tsx';

const productFruitsOnboarding = () => {
  const session = getAccessToken();
  const user = jwtDecode(session);

  const hasGrowIntel = user?.products?.includes(ProductType.GROWINTEL);
  const hasGrowDash = user?.products?.includes(ProductType.GROWDASH);
  const newUser = user?.products?.length === 0;

  if ((hasGrowIntel && !hasGrowDash) || newUser) {
    return <></>;
  }

  const userInfo = {
    username: user?.username || '',
    email: user?.username || ''
  };

  const PF_KEY: string =
    import.meta.env.VITE_REACT_APP_PRODUCT_FRUITS_KEY?.toString() || '';
  if (!session) return <></>;

  return <ProductFruits workspaceCode={PF_KEY} language='en' user={userInfo} />;
};

export default productFruitsOnboarding;
